import { ChangeDetectionStrategy, Component, input, output, signal, WritableSignal } from '@angular/core';
import { form, FormField } from '@angular/forms/signals';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { PlanAdminFilterKey, ZoudashUtils } from '@workspace/data-types';
import {
  AbstractSignalFormComponent,
  DataHeaderFilter,
  FilterChangedDetection,
  FilterRecord,
} from '@workspace/ng-aura';
import { PlanColumnKey } from '../abstract-plans-data-table.component';

export interface PlanFilterModel {
  billingCycle: string | string[] | null;
  isActive: string | string[] | null;
}

@Component({
  selector: 'core-plans-data-table-filter',
  templateUrl: './plans-data-table-filter.component.html',
  imports: [FormField, MatFormFieldModule, MatInputModule, MatListModule, MatSlideToggleModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlansDataTableFilterCoreComponent extends AbstractSignalFormComponent<
  Partial<Record<PlanAdminFilterKey, string | string[]>>,
  PlanFilterModel
> {
  filterChanged = output<FilterChangedDetection>();
  currentFilterView = input<string | null>(null);
  filters = input.required<DataHeaderFilter<PlanColumnKey>[]>();

  planAdminFilterKey = PlanAdminFilterKey;

  override model: WritableSignal<PlanFilterModel> = signal<PlanFilterModel>({
    billingCycle: null,
    isActive: null,
  });

  override formTree = form(this.model);

  override emitDto(newDto: Partial<Record<PlanAdminFilterKey, string | string[]>>): void {
    this.filterChanged.emit({
      filter: newDto as FilterRecord,
      changed: !ZoudashUtils.isEqual(newDto, this.ogValue),
    });
  }

  protected override buildModelFromDto(
    dto: Partial<Record<PlanAdminFilterKey, string | string[]>>,
  ): PlanFilterModel {
    return {
      billingCycle: dto?.[PlanAdminFilterKey.BillingCycle] ?? null,
      isActive: dto?.[PlanAdminFilterKey.IsActive] ?? null,
    };
  }

  protected override buildDtoFromModel(
    model: PlanFilterModel,
  ): Partial<Record<PlanAdminFilterKey, string | string[]>> {
    const dto: Partial<Record<PlanAdminFilterKey, string | string[]>> = {
      billingCycle: model.billingCycle ?? undefined,
      isActive: model.isActive ?? undefined,
    };
    return Object.fromEntries(Object.entries(dto).filter(([_, v]) => v != null)) as Partial<
      Record<PlanAdminFilterKey, string | string[]>
    >;
  }
}
